import ttt from '@xingternal/ticktricktrack';

export const trackEvent = (eventName, contextData) =>
  ttt.event(eventName, {
    ...contextData,
  });

export const trackAction = (contextData) =>
  ttt.event('PropTrackAction', {
    ...contextData,
  });
